<template>
  <ion-page v-if="sharedState.ui" :key="sharedState.language">
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
    
      <ion-tab-bar slot="bottom" dir="ltr">
        <ion-tab-button tab="tab1" href="/home#">
          <ion-icon aria-hidden="true" :icon="home" />
          <ion-label :aria-label="sharedState.ui.tabs.Home" class="ion-text-wrap">{{ sharedState.ui.tabs.Home }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/resources">
          <ion-icon aria-hidden="true" :icon="folder" />
          <ion-label :aria-label="sharedState.ui.tabs.Resources" class="ion-text-wrap">{{ sharedState.ui.tabs.Resources }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" :href="`/home/subsection/crisis-hotlines-${sharedState.language}`">
          <ion-icon aria-hidden="true" :icon="call" />
          <ion-label :aria-label="sharedState.ui.tabs.Hotlines ?? 'Crisis'" class="ion-text-wrap">{{ sharedState.ui.tabs.Hotlines ?? 'Crisis' }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab4" href="/relax">
          <ion-icon aria-hidden="true" :icon="musicalNotes" />
          <ion-label :aria-label="sharedState.ui.tabs.Relax" class="ion-text-wrap">{{ sharedState.ui.tabs.Relax }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab5" href="/settings">
          <ion-icon aria-hidden="true" :icon="settings" />
          <ion-label :aria-label="sharedState.ui.tabs.Settings" class="ion-text-wrap">{{ sharedState.ui.tabs.Settings }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>

    </ion-tabs>
  </ion-page>
</template>

<script>
import { IonPage, IonRouterOutlet, IonTabBar, IonTabs, IonTabButton, IonLabel, IonIcon } from '@ionic/vue';
import { home, folder, call, musicalNotes, settings } from 'ionicons/icons';
import { store } from '@/store';

export default {
  name: 'Tabs',
  components: { IonPage, IonRouterOutlet, IonTabBar, IonTabs, IonTabButton, IonLabel, IonIcon },
  setup() {
    return {
      home,
      folder,
      call,
      musicalNotes,
      settings,
    }
  },
  data() {
    return {
      sharedState: store.state,
    }
  },
  async mounted() {
    const lang = await store.getLanguage();
    const dir = (lang == 'ar' || lang == 'fa') ? 'rtl' : 'ltr';
    const thisEl = this.$el.querySelector('ion-router-outlet');
    thisEl.setAttribute('dir', dir);
    thisEl.setAttribute('animated', 'false');
  }

}
</script>

<style scoped>
ion-tab-bar { 
  min-height: 70px; 
  padding-bottom: var(--ion-safe-area-bottom);
}

ion-tab-button { width: 20%; }

ion-tab-button::part(native) { padding: 0 0.125em; }

ion-label { font-size: 0.625rem !important; }
</style>